module.exports = __webpack_public_path__ + "877274ae12f6eeee96f0a5a64ed3b2fd.svg";